import React__default from 'react';
import PropTypes from 'prop-types';
import { backgroundPresets, brands } from '../../tools/constants.js';

var propTypes = {
  /** The Touts or content to display inside the group. Typically a set of `Tout` components */
  children: PropTypes.node.isRequired,
  /** Background preset for the group (color or image) */
  background: PropTypes.oneOf(backgroundPresets),
  /** Brand identifier for styling */
  brand: PropTypes.oneOf(brands),
  /** Optional footer content, rendered below the touts */
  footer: PropTypes.node,
  /** Optional background node, rendered behind the tout group */
  groupBackground: PropTypes.node,
  /** If true, adds horizontal padding to the group */
  hasPaddingHorizontal: PropTypes.bool,
  /** If true, adds vertical padding to the group */
  hasPaddingVertical: PropTypes.bool,
  /** If true, displays a separator between touts */
  hasSeparator: PropTypes.bool,
  /** Optional header content, rendered above the touts */
  header: PropTypes.node,
  /** Layout and spacing variant for the group */
  variant: PropTypes.oneOf(['horizontal-collapsed', 'horizontal-spaced', 'vertical-collapsed', 'vertical-spaced'])
};
function ToutGroup(_ref) {
  var background = _ref.background,
    brand = _ref.brand,
    children = _ref.children,
    footer = _ref.footer,
    groupBackground = _ref.groupBackground,
    _ref$hasPaddingHorizo = _ref.hasPaddingHorizontal,
    hasPaddingHorizontal = _ref$hasPaddingHorizo === void 0 ? 'false' : _ref$hasPaddingHorizo,
    _ref$hasPaddingVertic = _ref.hasPaddingVertical,
    hasPaddingVertical = _ref$hasPaddingVertic === void 0 ? 'false' : _ref$hasPaddingVertic,
    _ref$hasSeparator = _ref.hasSeparator,
    hasSeparator = _ref$hasSeparator === void 0 ? 'false' : _ref$hasSeparator,
    header = _ref.header,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'horizontal-spaced' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group",
    "data-background": background,
    "data-brand": brand,
    "data-padding-horizontal": hasPaddingHorizontal,
    "data-padding-vertical": hasPaddingVertical,
    "data-separator": hasSeparator,
    "data-testid": "tout-group",
    "data-variant": variant
  }, groupBackground ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-background",
    "data-testid": "tout-group-background"
  }, groupBackground) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-wrapper",
    "data-testid": "tout-group-wrapper"
  }, header ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-header",
    "data-testid": "tout-group-header"
  }, header) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-content",
    "data-testid": "tout-group-content"
  }, children), footer ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-footer",
    "data-testid": "tout-group-footer"
  }, footer) : null));
}
ToutGroup.propTypes = propTypes;

export { ToutGroup as default };
//# sourceMappingURL=ToutGroup.js.map
